import React from "react";
import { useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Sparkles, ArrowRight, ShieldAlert } from "lucide-react";

export default function Login() {
  const location = useLocation();
  const accessError = location.state?.error;
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background p-6">
      <div className="pointer-events-none absolute -left-40 -top-40 h-96 w-96 rounded-full bg-primary/10 blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-40 -right-40 h-96 w-96 rounded-full bg-primary/5 blur-[120px]" />

      <div className="relative z-10 w-full max-w-md">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/15 ring-1 ring-primary/30">
            <span className="font-heading text-base font-bold text-primary">20</span>
          </div>
          <div className="leading-tight">
            <div className="font-heading text-xl font-bold tracking-tight">20/80LAB</div>
            <div className="text-[0.65rem] uppercase tracking-[0.15em] text-muted-foreground">Client Acquisition</div>
          </div>
        </div>

        <div className="rounded-2xl border border-border bg-card p-8">
          <div className="mb-1 flex items-center gap-2 label-caps text-primary">
            <Sparkles className="h-3.5 w-3.5" /> Client Acquisition System 1.0
          </div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Bentornato</h1>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
            Accedi per trovare, analizzare e acquisire clienti con la tua macchina commerciale.
          </p>

          {accessError && (
            <div className="mt-4 flex items-start gap-2 rounded-lg border border-destructive/40 bg-destructive/10 px-3 py-2.5 text-xs text-red-300" data-testid="access-error">
              <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0" />
              <span>{accessError}</span>
            </div>
          )}

          <Button onClick={handleLogin} className="mt-6 w-full" size="lg" data-testid="google-login-btn">
            <GoogleIcon /> Accedi con Google
            <ArrowRight className="ml-auto h-4 w-4" />
          </Button>

          <p className="mt-4 text-center text-xs text-muted-foreground">
            FIND → SCORE → AUDIT → MATCH → CONTACT → QUALIFY → CONVERT
          </p>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24" aria-hidden>
      <path fill="#FFF" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" opacity=".9" />
      <path fill="#FFF" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" opacity=".7" />
      <path fill="#FFF" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" opacity=".5" />
      <path fill="#FFF" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38z" opacity=".8" />
    </svg>
  );
}
